// extracted by mini-css-extract-plugin
module.exports = {"response-history-icon-wrapper":"ResponseHistory_response-history-icon-wrapper__2_oWt","response-history-body":"ResponseHistory_response-history-body__bd0_l"};